// Lightweight English/Hindi translations for key UI strings.
// Country content stays English-only (intentional; education quality > thin translation).

export const translations = {
  en: {
    nav: {
      home: "Home",
      countries: "Country Guides",
      visa: "Visa Guide",
      principles: "Civic Principles",
      quiz: "Quiz",
      checklist: "Trip Checklist",
      chat: "Ask Sanskaar",
      about: "About",
    },
    hero: {
      overline: "For Indians traveling abroad",
      title: "Travel like the world is watching — because it is.",
      sub: "A free, honest guide to civic sense, etiquette, and laws across countries. So every Indian abroad is welcomed back.",
      cta_primary: "Explore Country Guides",
      cta_secondary: "Take the Civic Quiz",
    },
    sections: {
      principles_title: "Eight rules that travel with you anywhere.",
      principles_sub: "These aren't just for one country. They're the global civic baseline.",
      countries_title: "Country-Specific Etiquette",
      countries_sub: "Each country has its own unspoken rules. Read before you fly.",
      tools_title: "Tools to Prepare You",
      tools_sub: "Test your awareness, get a personalized checklist, or ask Sanskaar anything.",
    },
    quiz: {
      start: "Start the Quiz",
      next: "Next",
      submit: "See My Result",
      score: "Your Score",
      retake: "Retake the Quiz",
      explanation: "Why",
    },
    checklist: {
      title: "Pre-Trip Civic Checklist",
      sub: "Pick your destination and trip type — we'll generate a custom prep list.",
      destination: "Destination",
      trip_type: "Trip Type",
      duration: "Duration (days)",
      generate: "Generate Checklist",
      common_items: "Universal Essentials",
      country_items: "Country-Specific Briefing",
      types: {
        leisure: "Leisure",
        business: "Business",
        family: "Family",
        student: "Student",
      },
    },
    chat: {
      title: "Ask Sanskaar",
      sub: "Your friendly AI guide for cultural etiquette and travel civics.",
      placeholder: "Ask anything — e.g. 'How do I tip in Italy?'",
      send: "Send",
      thinking: "Sanskaar is thinking…",
      suggestions: [
        "How do I tip in Italy?",
        "What's appropriate dress code for Dubai malls?",
        "Can I bring Indian medicines to Japan?",
        "What should I never do on the Tokyo metro?",
      ],
    },
    footer: {
      tagline: "Building Indians who travel well, behave well, and represent well.",
      built: "An educational project. Content curated for awareness, not legal advice.",
    },
  },
  hi: {
    nav: {
      home: "होम",
      countries: "देश गाइड",
      visa: "वीज़ा गाइड",
      principles: "नागरिक सिद्धांत",
      quiz: "क्विज़",
      checklist: "यात्रा चेकलिस्ट",
      chat: "संस्कार से पूछें",
      about: "हमारे बारे में",
    },
    hero: {
      overline: "विदेश यात्रा करने वाले भारतीयों के लिए",
      title: "ऐसे यात्रा करें जैसे दुनिया देख रही हो — क्योंकि वो देख रही है।",
      sub: "विदेशों में नागरिक भावना, शिष्टाचार और कानूनों की एक ईमानदार, मुफ्त गाइड। ताकि हर भारतीय का स्वागत हो।",
      cta_primary: "देश गाइड देखें",
      cta_secondary: "क्विज़ खेलें",
    },
    sections: {
      principles_title: "आठ नियम जो आपके साथ हर जगह जाते हैं।",
      principles_sub: "ये सिर्फ एक देश के लिए नहीं हैं। ये दुनिया का बुनियादी नागरिक आचरण है।",
      countries_title: "देश-विशिष्ट शिष्टाचार",
      countries_sub: "हर देश के अपने अनकहे नियम हैं। उड़ान से पहले पढ़ें।",
      tools_title: "आपकी तैयारी के लिए टूल्स",
      tools_sub: "अपनी जागरूकता परखें, चेकलिस्ट बनाएं, या संस्कार से कुछ भी पूछें।",
    },
    quiz: {
      start: "क्विज़ शुरू करें",
      next: "अगला",
      submit: "मेरा परिणाम देखें",
      score: "आपका स्कोर",
      retake: "फिर से क्विज़ लें",
      explanation: "क्यों",
    },
    checklist: {
      title: "यात्रा-पूर्व नागरिक चेकलिस्ट",
      sub: "अपना गंतव्य और यात्रा का प्रकार चुनें — हम कस्टम लिस्ट बनाएंगे।",
      destination: "गंतव्य",
      trip_type: "यात्रा का प्रकार",
      duration: "अवधि (दिन)",
      generate: "चेकलिस्ट बनाएं",
      common_items: "मूल आवश्यक चीज़ें",
      country_items: "देश-विशिष्ट जानकारी",
      types: {
        leisure: "अवकाश",
        business: "व्यापार",
        family: "परिवार",
        student: "छात्र",
      },
    },
    chat: {
      title: "संस्कार से पूछें",
      sub: "यात्रा शिष्टाचार के लिए आपका मित्रवत AI गाइड।",
      placeholder: "कुछ भी पूछें — जैसे 'इटली में टिप कैसे दें?'",
      send: "भेजें",
      thinking: "संस्कार सोच रहा है…",
      suggestions: [
        "इटली में टिप कैसे दें?",
        "दुबई के मॉल में क्या पहनें?",
        "क्या मैं जापान में भारतीय दवाएं ले जा सकता हूं?",
        "टोक्यो मेट्रो में क्या नहीं करना चाहिए?",
      ],
    },
    footer: {
      tagline: "ऐसे भारतीय बनाएं जो अच्छी यात्रा करें, अच्छा व्यवहार करें, और अच्छा प्रतिनिधित्व करें।",
      built: "एक शैक्षिक परियोजना। जागरूकता के लिए सामग्री, कानूनी सलाह नहीं।",
    },
  },
};
